import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../api';

const CATEGORIES = ['사업관리','영업관리','개발관리','품질관리','기타'];
const STATUSES   = ['진행중','완료','보류','검토중'];

export default function TaskDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [task, setTask]         = useState(null);
  const [comments, setComments] = useState([]);
  const [editing, setEditing]   = useState(false);
  const [form, setForm]         = useState({});
  const [comment, setComment]   = useState('');
  const [msg, setMsg]           = useState('');

  const loadTask = () => API.get(`/tasks/${id}`).then(r => { setTask(r.data); setForm(r.data); });
  const loadComments = () => API.get(`/tasks/${id}/comments`).then(r => setComments(r.data));

  useEffect(() => { loadTask(); loadComments(); }, [id]);

  const handleSave = async () => {
    await API.put(`/tasks/${id}`, form);
    setMsg('✅ 수정 완료!');
    setEditing(false);
    loadTask();
  };

  const handleComment = async () => {
    if (!comment.trim()) return;
    await API.post(`/tasks/${id}/comments`, { content: comment });
    setComment('');
    loadComments();
  };

  if (!task) return <div style={{ padding:40, color:'#aaa' }}>불러오는 중...</div>;

  return (
    <div style={{ padding:24, maxWidth:800 }}>
      {/* 뒤로가기 */}
      <button onClick={() => navigate('/tasks')} style={{ background:'none', border:'none', color:'#185FA5', cursor:'pointer', fontSize:13, marginBottom:16, padding:0 }}>← 목록으로</button>

      {/* 상세 카드 */}
      <div style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:12, padding:24, marginBottom:16 }}>
        {editing ? (
          <>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
              <div>
                <label style={lStyle}>카테고리</label>
                <select value={form.category} onChange={e => setForm({...form, category:e.target.value})} style={iStyle}>
                  {CATEGORIES.map(c => <option key={c}>{c}</option>)}
                </select>
              </div>
              <div>
                <label style={lStyle}>상태</label>
                <select value={form.status} onChange={e => setForm({...form, status:e.target.value})} style={iStyle}>
                  {STATUSES.map(s => <option key={s}>{s}</option>)}
                </select>
              </div>
            </div>
            <input value={form.title} onChange={e => setForm({...form, title:e.target.value})} style={{ ...iStyle, marginBottom:10, fontSize:16, fontWeight:500 }} />
            <input value={form.manager} onChange={e => setForm({...form, manager:e.target.value})} placeholder="담당자" style={{ ...iStyle, marginBottom:10 }} />
            <textarea value={form.content} onChange={e => setForm({...form, content:e.target.value})} rows={5} style={{ ...iStyle, resize:'vertical', marginBottom:14 }} />
            <div style={{ display:'flex', gap:8 }}>
              <button onClick={handleSave} style={btn('#185FA5')}>저장</button>
              <button onClick={() => setEditing(false)} style={btn('#888')}>취소</button>
            </div>
          </>
        ) : (
          <>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
              <div>
                <div style={{ display:'flex', gap:8, marginBottom:8 }}>
                  <span style={{ fontSize:12, padding:'3px 10px', borderRadius:20, background:'#E6F1FB', color:'#185FA5' }}>{task.status}</span>
                  <span style={{ fontSize:12, padding:'3px 10px', borderRadius:20, background:'#f1f5f9', color:'#555' }}>{task.category}</span>
                </div>
                <h2 style={{ fontSize:20, fontWeight:600, margin:'0 0 6px' }}>{task.title}</h2>
                <div style={{ fontSize:13, color:'#888' }}>담당: {task.manager || '-'} · 등록일: {task.created_at?.slice(0,10)}</div>
              </div>
              <button onClick={() => setEditing(true)} style={btn('#185FA5')}>✏️ 수정</button>
            </div>
            <hr style={{ margin:'16px 0', border:'none', borderTop:'1px solid #f1f5f9' }} />
            <div style={{ fontSize:14, color:'#333', lineHeight:1.8, whiteSpace:'pre-wrap' }}>{task.content || '내용 없음'}</div>
          </>
        )}
        {msg && <div style={{ marginTop:12, color:'#065f46', fontSize:13 }}>{msg}</div>}
      </div>

      {/* 댓글 (히스토리) */}
      <div style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:12, padding:20 }}>
        <h3 style={{ fontSize:15, fontWeight:600, marginBottom:14 }}>💬 히스토리 ({comments.length})</h3>
        {comments.map(c => (
          <div key={c.id} style={{ background:'#f8fafc', borderRadius:8, padding:'10px 14px', marginBottom:8 }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
              <span style={{ fontSize:13, fontWeight:500, color:'#185FA5' }}>{c.author_name}</span>
              <span style={{ fontSize:12, color:'#aaa' }}>{c.created_at?.slice(0,16)}</span>
            </div>
            <div style={{ fontSize:14, color:'#333', lineHeight:1.6 }}>{c.content}</div>
          </div>
        ))}
        {comments.length === 0 && <div style={{ color:'#aaa', fontSize:13, marginBottom:14 }}>아직 히스토리가 없습니다.</div>}

        {/* 댓글 입력 */}
        <div style={{ display:'flex', gap:8, marginTop:10 }}>
          <input value={comment} onChange={e => setComment(e.target.value)}
            placeholder="히스토리 내용을 입력하세요"
            onKeyDown={e => e.key === 'Enter' && handleComment()}
            style={{ ...iStyle, flex:1 }} />
          <button onClick={handleComment} style={btn('#185FA5')}>등록</button>
        </div>
      </div>
    </div>
  );
}

const lStyle = { fontSize:12, fontWeight:500, color:'#555', display:'block', marginBottom:4 };
const iStyle = { width:'100%', padding:'9px 12px', border:'1px solid #ddd', borderRadius:7, fontSize:14, boxSizing:'border-box', outline:'none' };
const btn = bg => ({ background:bg, color:'#fff', border:'none', borderRadius:7, padding:'8px 16px', fontSize:13, cursor:'pointer', fontWeight:500, whiteSpace:'nowrap' });